import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactTooltip from 'react-tooltip';

import {
  getIcon
} from '../../util';

import {
  fetchUserDataForEveryone
} from '../../actions';

import {
  fetchSprintHistoryForEveryone
} from '../../actions/sprint';

import SprintHistoryItem from './sprintHistoryItem';

class SprintHistoryReport extends Component {

  state = {
    showingLegend: false,
    userData: {},
  }

  componentDidMount(){
    this.props.fetchSprintHistoryForEveryone();
    this.props.fetchUserDataForEveryone(userData => {
      this.setState({
        userData: _.keyBy(userData, '_id')
      });
    }, true);
  }

  userData(userId){
    return this.state.userData[userId];
  }

  getHistoryRowWithOffset(offset = 0){

    const startDate = moment().startOf('isoWeek').subtract(offset, 'weeks');
    const endDate = moment().endOf('isoWeek').subtract(offset, 'weeks').subtract(2, 'days');//friday

    return {
      startDate,
      endDate,
      startLabel: startDate.format('M/D'),
      endLabel: endDate.format('M/D'),
    }
  }

  getCurrentHistoryItemRows(){
    return _.map(_.reverse([1,2,3,4,5,6,7,8,9,10]), this.getHistoryRowWithOffset.bind(this));
  }

  renderNoMatchingSprintHistoryItem(){
    return (
      <div className="history-item no-match">{getIcon('times')}</div>
    )
  }

  renderSprintHistoryItem(sprintHistory){
    return <SprintHistoryItem sprintHistory={sprintHistory} />
  }

  renderHistoryItemColumnHeaders(){
    return (
      <div className="history">
        {_.map(this.getCurrentHistoryItemRows(), rowData => {
          return (
            <div className="history-column-heading">
              <div className="start-label">{rowData.startLabel}</div>
              <div className="end-label">{rowData.endLabel}</div>
            </div>
          );
        })}
      </div>
    )
  }

  renderSprintHistoryRowForMember(memberId){
    const memberData = this.userData(memberId);

    const {
      sprintHistory
    } = this.props;

    if(!memberData || !sprintHistory){
      return null;
    }

    console.log('rendering sprint history for user: ', memberData);

    const currentHistoryItemRows = this.getCurrentHistoryItemRows();

    return (
      <div key={memberData._id} className={`row member ${memberData._deleted ? 'archived' : ''}`}>
        <div className="name">{memberData.firstName} {memberData.lastName}</div>
        <div className="history">
          {_.map(currentHistoryItemRows, rowData => {

            const matchingSprintHistory = _.find(sprintHistory, item => {
              // console.log('checking sprintHistory.userId', memberId, item.userId);
              // console.log('checking startDate: ', item.startDate, rowData.startDate.format('YYYYMMDD'));
              // console.log('checking endDate: ', item.startDate, rowData.endDate.format('YYYYMMDD'));

              return  item.userId === memberId &&
                      item.startDate === rowData.startDate.format('YYYYMMDD') &&
                      item.endDate === rowData.endDate.format('YYYYMMDD');
            });

            return matchingSprintHistory ? this.renderSprintHistoryItem(matchingSprintHistory) : this.renderNoMatchingSprintHistoryItem();

          })}
        </div>
      </div>
    )
  }
  renderSprintHistoryForTeam(team){

    const {
      name, leaders, members
    } = team;

    return (
      <div key={`sprint-history-for-team-${team._id}`} className="team-sprint-history">
        <div className="row meta">
          <div className="name">{name}</div>
          {this.renderHistoryItemColumnHeaders()}
        </div>
        {_.map(members, this.renderSprintHistoryRowForMember.bind(this))}
      </div>
    )
  }

  renderSprintHistoryForTeams(){
    return (
      <React.Fragment>
        {_.map(this.props.teams, team => {
          return this.renderSprintHistoryForTeam(team);
        })}
      </React.Fragment>
    )
  }

  showLegend(){
    this.setState({
      showingLegend: true
    });
  }

  render(){

    const { showingLegend } = this.state;

    return (
      <div className="report sprint-history">
        <div onClick={() => { this.showLegend(); }} className={`report-legend ${showingLegend ? 'showing' : ''}`}>
          {!showingLegend && <div className="toggle">Show legend</div>}
          {showingLegend &&
            <React.Fragment>
              {/*<div className="example-row">
                <div className="example-item activity">A</div>
                <div className="example-label">Activity Weighted Score <small>(0-100)</small></div>
              </div>
              <div className="example-row">
                <div className="example-item development">C</div>
                <div className="example-label">Development Weighted Score <small>(0-100)</small></div>
              </div>
              <div className="example-row">
                <div className="example-item missing">{getIcon('times')}</div>
                <div className="example-label">Missing Score</div>
              </div>*/}
              <div className="example-row">
                <div data-html={true} data-for="activity-calculation-explanation" data-tip="The Activity weighted score is a user's average activity completion percentage for the week. Each actitiy item is capped at 100%." className="tooltip-icon">{getIcon('info-bold')}</div>
                <ReactTooltip id="activity-calculation-explanation" effect="solid" place="left" />
                <div className="example-items">
                  <div className="example-item activity letter-A">A <small>90+</small></div>
                  <div className="example-item activity letter-B">B <small>80-89</small></div>
                  <div className="example-item activity letter-C">C <small>70-79</small></div>
                  <div className="example-item activity letter-D">D <small>60-69</small></div>
                </div>
                <div className="example-label">Activity Weighted Score</div>
              </div>
              <div className="example-row">
                <div data-html={true} data-for="development-calculation-explanation" data-tip="The Development weighted score is a user's overall behavior & skill development completion percentage for the week.<br/>Users with more than 3 development items are given a slight correction corresponding to the number of items." className="tooltip-icon">{getIcon('info-bold')}</div>
                <ReactTooltip id="development-calculation-explanation" effect="solid" place="left" />
                <div className="example-items">
                  <div className="example-item development letter-A">A <small>55+</small></div>
                  <div className="example-item development letter-B">B <small>40-54</small></div>
                  <div className="example-item development letter-C">C <small>25-39</small></div>
                  <div className="example-item development letter-D">D <small>1-24</small></div>
                </div>
                <div className="example-label">Development Weighted Score</div>
              </div>
              <div className="example-row">
                <div data-html={true} data-for="missing-explanation" data-tip="This means that we don't have data for this week for a user. This could be because no sprint was submitted, or that it was finalized with the incorrect dates." className="tooltip-icon">{getIcon('info-bold')}</div>
                <ReactTooltip id="missing-explanation" effect="solid" place="left" />
                <div className="example-items">
                  <div className="example-item missing">{getIcon('times')}</div>
                </div>
                <div className="example-label">Missing Score</div>
              </div>
            </React.Fragment>
          }
        </div>
        {this.renderSprintHistoryForTeams()}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    sprintHistory: state.sprintHistory.data,
    fetchingSprintHistory: state.sprintHistory.loading,
    teams: state.teams.data,
  }
}

export default connect(mapStateToProps, { fetchSprintHistoryForEveryone, fetchUserDataForEveryone })(SprintHistoryReport);



// WEBPACK FOOTER //
// ./src/components/reports/sprintHistory.js